interface PROJECT_TAB_CONSTANTS_TYPE {
    PROJECT_UPLOAD_CANDIDATES: string;
    PROJECT_INBOUND_APPLICATION: string;
    PROJECT_RECOMMEND_MATCH: string;
    PROJECT_SEARCH: string;
}

export const PROJECT_TAB_CONSTANTS: PROJECT_TAB_CONSTANTS_TYPE = {
    PROJECT_UPLOAD_CANDIDATES: 'project-upload-candidates',
    PROJECT_INBOUND_APPLICATION: 'project-inbound-applications',
    PROJECT_RECOMMEND_MATCH: 'project-recommand-match',
    PROJECT_SEARCH: 'project-search'
};

export class ProjectConstants {
    static readonly PROJECT_TAB_CONSTANTS = PROJECT_TAB_CONSTANTS;
}